module.exports = __webpack_public_path__ + "static/img/banner2.0370f2ed.jpg";